'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'arrow-left';
var width = 576;
var height = 512;
var aliases = [8592];
var unicode = 'f060';
var svgPathData = 'M41.6 233.4l-22.6 22.6 22.6 22.6 160 160 22.6 22.6 45.3-45.3c-1.3-1.3-44-44-128-128l402.7 0 0-64-402.7 0c84-84 126.7-126.7 128-128l-45.3-45.3-22.6 22.6-160 160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowLeft = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;